import PropTypes from "prop-types";
import "./styles.css";
import { capitaliseFirstLetter } from "../../../helpers";
import { useLeadForm } from "../../../context/leadform";
import { OptionType } from "../../../Leadform/options";

type RadioListProps = {
  options: OptionType[];
  statekey: string;
  label?: string;
  inline?: boolean;
  reverse?: boolean;
  perRow?: number;
};

function RadioList({
  options,
  label,
  inline,
  reverse,
  perRow,
  statekey,
}: RadioListProps) {
  const { responses, updateValue } = useLeadForm();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateValue(statekey, e.target.value);
  };

  return (
    <div
      className={`RadioList Rows${perRow} RadioList_${statekey} RadioList_Inline_${inline} RadioList_Reverse_${reverse} RadioList_Length_${options.length}`}
    >
      {inline && <label htmlFor={statekey}>{label}</label>}
      <div className="RadioListItems">
        {options.map((option, index) => (
          <div className="RadioListItem" key={index}>
            <input
              type="radio"
              id={`${statekey}${index}`}
              name={statekey}
              checked={responses[statekey] === option.value}
              value={option.value}
              onChange={handleChange}
            />
            <label htmlFor={`${statekey}${index}`}>
              <p>{capitaliseFirstLetter(option.label)}</p>
              {option.icon}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RadioList;
